/**
 * Gentle scroll-in for partner section columns: fade + slide toward center.
 */

import type { CSSProperties } from "react";

export type PartnerRevealSide = "left" | "right";

/** How far each column starts from its rest position (px). */
export const PARTNER_REVEAL_DISTANCE_PX = 28;
export const PARTNER_REVEAL_DURATION_MS = 700;
export const PARTNER_REVEAL_EASE = "cubic-bezier(0.22, 1, 0.36, 1)";
/** Stagger the trailing column so the move reads as a pair. */
export const PARTNER_REVEAL_STAGGER_MS = 120;

export function partnerColumnRevealStyle(
  isVisible: boolean,
  side: PartnerRevealSide,
  options?: { delayMs?: number }
): CSSProperties {
  const fromX = side === "left" ? -PARTNER_REVEAL_DISTANCE_PX : PARTNER_REVEAL_DISTANCE_PX;
  const delayMs = options?.delayMs ?? 0;
  return {
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translate3d(0, 0, 0)" : `translate3d(${fromX}px, 0, 0)`,
    transition: `opacity ${PARTNER_REVEAL_DURATION_MS}ms ${PARTNER_REVEAL_EASE}, transform ${PARTNER_REVEAL_DURATION_MS}ms ${PARTNER_REVEAL_EASE}`,
    transitionDelay: isVisible && delayMs > 0 ? `${delayMs}ms` : "0ms",
  };
}

/** Tailwind-friendly class for reduced-motion users. */
export const PARTNER_REVEAL_MOTION_CLASS =
  "motion-reduce:!opacity-100 motion-reduce:!translate-x-0 motion-reduce:!transition-none";
